const style = {
    chatButton: {
        backgroundColor: '#3a5a40',
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        fontSize: '50px',
        cursor: 'pointer',
        borderRadius: '100px',
        border: 'none',
        boxShadow: '0 5px 10px #ccc',
        height: '55px',
        minWidth: '40px',
    },
}
export default style;